import * as types from "./../actions/actions";

const initialState = {
  isAuthenticated: false,
  users: [],
  buyerAgents: [],
  profileData: {},
  isMasterTemplateUpdated: false,
  isEventCommCreated: false,
  isMasterTemplateTaskDeleted: false,
  status: false,
  renderSidebar: 0,
  renderHeader: 0,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.REGISTER_USER:
      return Object.assign({}, state, {
        status: action.status,
        RegMessage: action.RegMessage,
      });

    case types.LOGIN_USER:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        LoginMessage: action.LoginMessage,
      });

    case types.REGISTRATION_REQUESTS:
      return Object.assign({}, state, {
        users: action.users,
        totalUsers: action.totalUsers,
      });

    case types.LOGOUT:
      return Object.assign({}, state, {
        isAuthenticated: false,
      });

    case types.ACTIVE_USER:
      return Object.assign({}, state, {
        status: action.status,
        UserMessage: action.UserMessage,
      });

    case types.BUYER_AGENT_LIST:
      return Object.assign({}, state, {
        buyerAgents: action.buyerAgents,
        totalBuyerAgents: action.totalBuyerAgents,
      });

    case types.MY_PROFILE:
      return Object.assign({}, state, {
        profileData: action.profileData,
      });

    case types.UPDATE_PROFILE:
      return Object.assign({}, state, {
        updatedProfileData: action.updatedProfileData,
      });

    case types.ADMIN_INVITE_AGENT:
      return Object.assign({}, state, {
        invieAgentMsg: action.invieAgentMsg,
        checkStatus: action.checkStatus,
      });

    case types.ADMIN_GET_MASTER_TEMPLATE_DATA:
      return Object.assign({}, state, {
        adminMasterTemplates: action.adminMasterTemplates,
        totalAdminTemplates: action.totalAdminTemplates,
      });

    case types.ADMIN_UPDATE_MASTER_TEMPLATE_DATA:
      return Object.assign({}, state, {
        isMasterTemplateUpdated: action.isMasterTemplateUpdated,
        updatedEventData: action.updatedEventData,
      });

    case types.CREATE_EVENT_COMM_MASTER_TEMPLATE:
      return Object.assign({}, state, {
        isEventCommCreated: action.isEventCommCreated,
        addedEventComm: action.addedEventComm,
      });

    case types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF:
      return Object.assign({}, state, {
        variablesRefs: action.variablesRefs,
      });

    case types.DELETE_EVENT_COMM_MASTER_TEMPLATE:
      return Object.assign({}, state, {
        isMasterTemplateTaskDeleted: action.isMasterTemplateTaskDeleted,
      });

    case types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID:
      return Object.assign({}, state, {
        campDataById: action.campDataById,
      });

    case types.CREATE_CAMPAIGN_MASTER_TEMPLATE:
    case types.COPY_CAMPAIGN_MASTER_TEMPLATE:
      return Object.assign({}, state, {
        isCampaignCreated: action.isCampaignCreated,
        addedCampaign: action.addedCampaign,
      });

    case types.GET_CONTINGENCIES:
      return Object.assign({}, state, {
        contingencies: action.contingencies,
      });

    case types.ADD_CONTACT:
      return Object.assign({}, state, {
        contactResponse: action.contactResponse,
      });

    case types.EDIT_CONTACT:
      return Object.assign({}, state, {
        contactResponse: action.contactResponse,
      });

    case types.GET_CONTACT:
      return Object.assign({}, state, {
        contacts: action.contacts,
      });

    case types.GET_ROLES:
      return Object.assign({}, state, {
        roles: action.roles,
      });

    case types.GET_BY_ID_CONTACT:
      return Object.assign({}, state, {
        contact: action.contact,
      });

    case types.BUYER_GET_MASTER_TEMPLATE_DATA:
      return Object.assign({}, state, {
        buyerMasterTemplates: action.buyerMasterTemplates,
        totalBuyerTemplates: action.totalBuyerTemplates,
      });

    case types.BUYER_CREATE_TASK:
      return Object.assign({}, state, {
        isEventCommCreated: action.isEventCommCreated,
        addedEventComm: action.addedEventComm,
      });

    case types.BUYER_UPDATE_MASTER_TEMPLATE_DATA:
      return Object.assign({}, state, {
        isMasterTemplateUpdatedBuyer: action.isMasterTemplateUpdatedBuyer,
        updatedEventDataBuyer: action.updatedEventDataBuyer,
      });

    case types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER:
      return Object.assign({}, state, {
        BuyerCampDataById: action.BuyerCampDataById,
      });

    case types.BUYER_CREATE_MASTER_TEMPLATE:
      return Object.assign({}, state, {
        newCampaign: action.newCampaign,
      });

    case types.CREATE_TRANSACTION:
      return Object.assign({}, state, {
        isTrascationCreated: action.isTrascationCreated,
        createTransactionData: action.createTransactionData,
      });

    case types.GET_ALL_TRANSACTIONS:
      return Object.assign({}, state, {
        transactions: action.transactions,
      });

    case types.GET_ALL_CONTINGENCIES:
      return Object.assign({}, state, {
        allContingencies: action.allContingencies,
      });

    case types.GET_ALL_TASKS:
      return Object.assign({}, state, {
        tasks: action.tasks,
      });

    case types.GET_TASK_DETAILS:
      return Object.assign({}, state, {
        taskDetails: action.taskDetails,
      });

    case types.GET_TRANSACTION:
      return Object.assign({}, state, {
        transactionData: action.transactionData,
      });

    case types.UPDATE_TRANSACTION:
      return Object.assign({}, state, {
        updatedTransData: action.updatedTransData,
      });

    case types.FORGOT_PASSWORD:
      return Object.assign({}, state, {
        forgotdata: action.forgotdata,
      });

    case types.VALIDATE_RESET_TOKEN:
      return Object.assign({}, state, {
        tokenfailed: action.tokenfailed,
      });

    case types.DELETE_TRANSACTION:
      return Object.assign({}, state, {
        isDTransDeleted: action.isDTransDeleted,
      });

    case types.VENDORS_LIST:
      return Object.assign({}, state, {
        vendorUsers: action.vendorUsers,
        totalVendors: action.totalVendors,
      });
    case types.GET_SYSTEMBANNERS:
      return Object.assign({}, state, {
        systemBanners: action.systemBanners,
        totalBanners: action.totalBanners,
      });
    case types.REMOVED_REGISTRATION:
    case types.REMOVED_USER:
    case types.REJECT_REGISTRATION:
      return Object.assign({}, state, {
        UserMessage: action.UserMessage,
        status: action.status,
      });

    case types.REJECT_REGISTRATION_LIST:
      return Object.assign({}, state, {
        users: action.users,
        status: action.status,
        totalRejectedUsers: action.totalRejectedUsers,
      });

    case types.GET_DEPENDENCY_DATA:
      return Object.assign({}, state, {
        dependencyTasks: action.dependencyTasks,
      });

    case types.PUT_DEPENDENCY_DATA:
      return Object.assign({}, state, {
        dependencyTasks: action.dependencyTasks,
        status: action.status,
        statusMessage: action.statusMessage,
      });

    case types.GET_ALL_VENDOR_TRANSACTIONS:
      return Object.assign({}, state, {
        vendorTransactions: action.vendorTransactions,
      });

    case types.GET_ALL_VENDOR_TASKS:
      return Object.assign({}, state, {
        vendorTasks: action.vendorTasks,
      });

    case types.TRANSACTION_STATUS:
      return Object.assign({}, state, {
        transactionStatus: action.transactionStatus,
      });

    case types.TRANSACTION_DEPEDENDENT_TASK:
      return Object.assign({}, state, {
        transactionTaskStatus: action.transactionTaskStatus,
      });

    case types.GET_ALL_BUYER_TRANSACTIONS:
      return Object.assign({}, state, {
        buyerTransactions: action.buyerTransactions,
      });

    case types.GET_ALL_BUYER_TASKS:
      return Object.assign({}, state, {
        buyerTasks: action.buyerTasks,
      });

    case types.TRANSACTION_ACTIVITY:
      return Object.assign({}, state, {
        transactionActivities: action.transactionActivities,
      });

    case types.TRANSACTION_ACTIVITY_USER:
      return Object.assign({}, state, {
        activityUsers: action.activityUsers,
      });

    case types.BUYERS_LIST:
      return Object.assign({}, state, {
        buyers: action.buyers,
        totalbuyers: action.totalbuyers,
      });

    case types.GET_UPCOMING_TASKS_DASHBOARD:
      return Object.assign({}, state, {
        upcomingTasksData: action.upcomingTasksData,
      });

    case types.DASHBOARD_TRANSACTIONS_VALUE:
      return Object.assign({}, state, {
        valuesData: action.valuesData,
      });

    case types.DASHBOARD_TRANSACTIONS:
      return Object.assign({}, state, {
        dashboardTranscations: action.dashboardTranscations,
        countTransactions: action.countTransactions,
      });

    case types.GET_LEAD_SOURCE_OPTIONS:
      return Object.assign({}, state, {
        options: action.options,
      });

    case types.DASHBOARD_COMMISSION:
      return Object.assign({}, state, {
        commissionData: action.commissionData,
      });

    case types.GET_ADD_FROM_ZIPCODE:
      return Object.assign({}, state, {
        addressData: action.addressData,
      });

    case types.LIST_ADMIN_USERS:
      return Object.assign({}, state, {
        adminUsers: action.adminUsers,
        totalAdminUsers: action.totalAdminUsers,
      });

    case types.ADD_ADMIN_USER:
      return Object.assign({}, state, {
        addedAdminUser: action.addedAdminUser,
        isAdminAdded: action.isAdminAdded,
      });

    case types.DISC_THREADS:
      return Object.assign({}, state, {
        threads: action.threads,
      });

    case types.MESSAGES_LIST:
      return Object.assign({}, state, {
        messages: action.messages,
      });

    case types.REPLY_MSG:
      return Object.assign({}, state, {
        replyRes: action.replyRes,
      });

    case types.RESEND_MSG:
      return Object.assign({}, state, {
        resendRes: action.resendRes,
      });

    case types.EMAIL_TEMPLATES:
      return Object.assign({}, state, {
        templates: action.templates,
      });

    case types.UPDATE_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        updatedEmailTemplate: action.updatedEmailTemplate,
      });

    case types.ADMIN_SYS_NOTIFICATION:
      return Object.assign({}, state, {
        sysNotifications: action.sysNotifications,
      });

    case types.USER_NOTIFICATIONS:
      return Object.assign({}, state, {
        userNotifications: action.userNotifications,
      });

    case types.USER_NOTIFICATIONS_SETTINGS:
      return Object.assign({}, state, {
        usernotificationSettings: action.usernotificationSettings,
      });
    case types.UPDATE_NOTIFICATIONS_SETTINGS:
      return Object.assign({}, state, {
        updatedSettings: action.updatedSettings,
      });

    case types.CLEAR_NOTIFICATIONS:
      return Object.assign({}, state, {
        clearNotiRes: action.clearNotiRes,
      });
    case types.READ_NOTIFICATIONS:
      return Object.assign({}, state, {
        readNotiRes: action.readNotiRes,
      });
    case types.GET_SPECIAL_TASKS:
      return Object.assign({}, state, {
        specialTask: action.specialTask,
      });
    case types.DASHBOARD_TASK_LIST:
      return Object.assign({}, state, {
        taskList: action.taskList,
        totalTasks: action.totalTasks,
      });
    case types.FOLDER_LIST:
      return Object.assign({}, state, {
        folderList: action.folderList,
      });
    case types.FOLDER_LIST:
      return Object.assign({}, state, {
        folderPermission: action.folderPermission,
      });
    case types.SUBSCRIPTION_DATA:
      return Object.assign({}, state, {
        subscriptionData: action.subscriptionData,
        totalSubscription: action.totalSubscription,
      });
    case types.REMOVE_DOC:
      return Object.assign({}, state, {
        status: action.status,
      });
    case types.ADD_SUBSCRIPTION:
      return Object.assign({}, state, {
        subscriptionData: action.subscriptionData,
      });
    case types.GET_ALL_SUBSCRIPTION:
      return Object.assign({}, state, {
        subscriptions: action.subscriptions,
      });
    case types.DELETE_IMAGE:
      return Object.assign({}, state, {
        isImageDeleted: action.isImageDeleted,
      });
    case types.REMOVE_PRODUCT:
      return Object.assign({}, state, {
        isProductDeleted: action.isProductDeleted,
      });
    case types.ACCOUNT_INFO:
      return Object.assign({}, state, {
        accountInfo: action.accountInfo,
      });
    case types.ADD_PAYMENT:
      return Object.assign({}, state, {
        paymentData: action.paymentData,
      });
    case types.REMOVE_PAYMENT_METHOD:
      return Object.assign({}, state, {
        isPaymentDeleted: action.isPaymentDeleted,
      });
    case types.GET_PRORATION:
      return Object.assign({}, state, {
        proration: action.proration,
      });
    case types.INVITED_USER:
      return Object.assign({}, state, {
        userDetails: action.userDetails,
      });
    case types.INVOICE_LIST:
      return Object.assign({}, state, {
        invoiceList: action.invoiceList,
      });
    case types.PENDING_PROFILE:
      return Object.assign({}, state, {
        userDetails: action.userDetails,
        totalPending: action.totalPending,
      });
    case types.STRIPE_SETTING:
      return Object.assign({}, state, {
        stripeEnable: action.stripeEnable,
      });
    case types.GET_TIME_ZONE:
      return Object.assign({}, state, {
        timezoneList: action.timezoneList,
      });
    case types.GET_HEAR_ABOUT_US:
      return Object.assign({}, state, {
        hearAboutUs: action.hearAboutUs,
      });
    case types.TRANSACTION_TYPE:
      return Object.assign({}, state, {
        transactionType: action.transactionType,
      });
    case types.GET_PUBLIC_FORM_BY_ID:
      return Object.assign({}, state, {
        getPublicFormData: action.getPublicFormData,
      });
    case types.UPDATE_PUBLIC_FORM:
      return Object.assign({}, state, {
        updatedPublicFormData: action.updatedPublicFormData,
      });
    case types.DELETE_PUBLIC_FORM:
      return Object.assign({}, state, {
        isPublicFormDeleted: action.isPublicFormDeleted,
      });
    case types.ADD_PUBLIC_FORM:
      return Object.assign({}, state, {
        addPublicFormData: action.addPublicFormData,
      });
    case types.IS_PUBLIC_FORM_VALID:
      return Object.assign({}, state, {
        isPublicFormValid: action.isPublicFormValid,
      });
    case types.TRANSACTION_PATHWAYS_LIST:
      return Object.assign({}, state, {
        transactionPathwaysData: action.transactionPathwaysData,
      });
    case types.RENDERSIDEBAR:
      return {
        ...state,
        renderSidebar: action.payload,
      };
    case types.RENDERHEADER:
      return {
        ...state,
        renderHeader: action.payload,
      };
    case types.GET_TRANS_TOTAL_PAYMENT:
      return Object.assign({}, state, {
        transPaymentData: action.transPaymentData,
      });
    case types.GET_All_SHOPS:
      return Object.assign({}, state, {
        shops: action.shops,
        totalPages: action.totalPages,
      });
    case types.GET_ARTIST_AVAILABLE_DATES:
      return Object.assign({}, state, {
        artistAvailableDates: action.artistAvailableDates,
      });
    default:
      return state;
  }
}

export default reducer;
